import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { actions as suggestionsActions } from '../../../../store/suggestions';

const useClearSuggestions = () => {
  const dispatch = useDispatch();

  const clearSuggestions = useCallback(() => {
    dispatch(suggestionsActions.clear());
  }, [dispatch]);

  return clearSuggestions;
};

export default useClearSuggestions;
